import { cn } from 'lib/utils';
import { Typography } from 'components/ui/typography';
import useTheme from 'hooks/useTheme';
import { ThemeMode } from 'providers/ThemeProvider';

type EmptyStateProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  iconLight?: string;
  iconDark?: string;
  imageClassName?: string;
  className?: string;
};

// Soft radial fade so the 32px grid lattice dissolves at the edges of the
// backdrop instead of meeting the page abruptly.
const GRID_FADE_MASK = 'radial-gradient(circle at center, black, transparent 65%)';

export const EmptyState = ({
  title,
  description,
  icon,
  iconLight,
  iconDark,
  imageClassName,
  className,
}: EmptyStateProps) => {
  const { theme } = useTheme();

  const iconNode =
    icon ??
    (iconLight && iconDark ? (
      <img
        src={theme === ThemeMode.Light ? iconLight : iconDark}
        alt=""
        className={cn('w-[150px]', imageClassName)}
      />
    ) : null);

  return (
    <div
      className={cn(
        'my-[10vw] flex flex-col items-center justify-center gap-6 text-center',
        className,
      )}
    >
      {iconNode && (
        <div className="relative grid h-[320px] w-[320px] place-items-center">
          <div
            aria-hidden
            className="has-grid pointer-events-none absolute inset-0"
            style={{ maskImage: GRID_FADE_MASK, WebkitMaskImage: GRID_FADE_MASK }}
          />
          <div className="relative">{iconNode}</div>
        </div>
      )}
      {title && (
        <Typography variant="h3" as="h3">
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="small" as="p">
          {description}
        </Typography>
      )}
    </div>
  );
};
